import axios from 'axios';

export const submittedAssetsPhoto = async ({
  submittedPhotoId,
  submitId,
  formData
}: {
  submitId: number;
  submittedPhotoId: number;
  formData: FormData;
}) => {
  const { data } = await axios.put(
    `/inspections/locations/${submitId}/tag-photos/${submittedPhotoId}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return data;
};
export const tagAdditionalStructuresPhoto = async ({
  additionalPhotoId,
  submitId,
  formData
}: {
  submitId: number;
  additionalPhotoId: number;
  formData: FormData;
}) => {
  const { data } = await axios.put(
    `/inspections/locations/${submitId}/tag-photos/${additionalPhotoId}/additional-structures`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return data;
};

export const getRoomIssues = async ({
  submitId,
  roomIssuesId
}: {
  submitId: string;
  roomIssuesId: string;
}) => {
  const { data } = await axios.get(
    `/inspections/locations/${submitId}/room-issues/${roomIssuesId}`
  );
  return data;
};

export type PayloadRoomIssues = {
  type?: string;
  description?: string;
  actionBy?: string;
  actionByDate?: string;
  validated?: boolean;
  options?: string;
  singleFields?: string;
  status?: string;
  archived?: boolean;
  resolutionDate?: string | null;
  file?: File;
};
export const UpdateRoomIssues = async ({
  submitId,
  roomIssuesId,
  payload
}: {
  submitId: string;
  roomIssuesId: string;
  payload: PayloadRoomIssues;
}) => {
  const formData = new FormData();
  for (const key in payload) {
    const value = payload[key as keyof PayloadRoomIssues];
    if (value === undefined || value === null) continue;
    if (typeof value === 'boolean') {
      formData.append(key, value ? 'true' : 'false');
      continue;
    }
    if (value !== '') formData.append(key, value as string | Blob);
  }
  const { data } = await axios.put(
    `/inspections/locations/${submitId}/room-issues/${roomIssuesId}`,
    formData
  );
  return data;
};

export const getDocumentsOption = async ({
  submitId,
  submittedAssets
}: {
  submitId: number;
  submittedAssets: number;
}) => {
  const { data } = await axios.get(
    `/inspections/locations/${submitId}/submitted-assets/${submittedAssets}/documentations`
  );
  return data;
};
export const uploadDocumentsOption = async ({
  submitId,
  submittedAssets,
  payload
}: {
  submitId: number;
  submittedAssets: number;
  payload: {
    files?: File[];
    deleteDocumentIds: number[];
  };
}) => {
  const formData = new FormData();
  if (payload?.files) {
    payload?.files.forEach((file) => {
      formData.append('files', file);
    });
  }
  if (payload.deleteDocumentIds) {
    formData.append('deleteDocumentIds', JSON.stringify(payload.deleteDocumentIds));
  }
  const { data } = await axios.post(
    `/storages/inspections/${submitId}/submitted-assets/${submittedAssets}/documentations`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return data;
};

export const deleteRoomIssue = async ({
  submitId,
  roomIssuesId
}: {
  submitId: string;
  roomIssuesId: string;
}) => {
  const { data } = await axios.delete(
    `/inspections/locations/${submitId}/room-issues/${roomIssuesId}`
  );
  return data;
};

export const compressImage = async (url: string) => {
  const { data } = await axios.put(`${url}/compress`);
  return data;
};

export type ArchivedInspectionPhoto = {
  source: string;
  sourceLabel: string;
  /** Outside / interior / wall N / additional slot for inspection location photos */
  photoSubtype?: string | null;
  junctionId: number;
  storageId: number | null;
  /** Room-level issue id, submitted asset id, issue report id, custom attribute id, structure id, or submit id for location photos */
  entityId: number | null;
  archivedAt: string;
  url: string;
  storageType: string | null;
};

export const getArchivedInspectionPhotos = async (submitId: number) => {
  const { data } = await axios.get<{ success: boolean; photos: ArchivedInspectionPhoto[] }>(
    `/inspections/locations/${submitId}/archived-photos`
  );
  return data;
};

/** Archived photos for all inspections at this physical location (room). */
export const getArchivedInspectionPhotosByRoom = async (roomId: number) => {
  const { data } = await axios.get<{ success: boolean; photos: ArchivedInspectionPhoto[] }>(
    `/inspections/locations/by-room/${roomId}/archived-photos`
  );
  return data;
};
